export enum StageCtaButtonsDisplayMethod {
  Manual = 'manual',
  Automate = 'automate',
}
